/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from 'react';
import { connect, useDispatch } from 'react-redux';
import {
  Container, Box, Typography, Grid, Button,
  IconButton, Tooltip,
  useTheme,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles, styled } from '@material-ui/core/styles';
import { useForm } from 'react-hook-form';
import PersonOutlinedIcon from '@material-ui/icons/PersonOutlined';
import HowToRegOutlinedIcon from '@material-ui/icons/HowToRegOutlined';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import EditIcon from '@material-ui/icons/EditOutlined';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ErrorIcon from '@material-ui/icons/Error';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import CircularProgress from '@material-ui/core/CircularProgress';
import CustomDialog from '../../components/marketPlace/Modal';
import WarningLicenseAssignment from '../../components/marketPlace/Warning/LicenseAssignment';
import {
  updateLicenseInReduxAction,
  deleteLicenseAssignmentAction,
  saveProductsAssignmentsAction,
  getContractSupervisiorInfoAction,
  GetCountriesFlagsAction,
} from '../../actions/license.action';
import { Rules } from '../../helpers/RHFRules';
import Success from '../../components/marketPlace/Succesfull';
import { getDocumentTypesAction, getParmeterConfigAction } from '../../actions/general.action';
import verifiedLicense from '../../assets/img/marketPlace/VerifiedLicense.svg';
import GroupsPerson from '../../assets/img/marketPlace/GroupsPerson.svg';
import CustomInput from '../../components/marketPlace/CustomInput';
import { RulesAndRegex } from '../../helpers/RHFRulesAndRegex';
import CustomSelect from '../../components/marketPlace/CustomSelect';
import CustomAutocompleteImage from '../../components/marketPlace/CustomAutocompleteImage';
import { getBlackListEmailsAction } from '../../actions/email.action';
import { LOADING_CONTRACT_SUPERVISOR_INFO, GET_CONTRACT_SUPERVISOR_INFO } from '../../types/license.type';

const getInputStyles = (theme) => ({
  marginRight: 10,
  '& .MuiOutlinedInput-root': {
    backgroundColor: theme.body.form2.backgcolor,
    borderRadius: '10px',
    height: '45px',
    '& fieldset': {
      borderColor: theme.body.form2.field,
    },
    '&:hover fieldset': {
      borderColor: theme.body.form2.borderr,
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.body.form2.borderr,
    },
  },
  '& .MuiSelect-select.MuiSelect-select': {
    fontFamily: 'Raleway',
    fontSize: '14px',
    color: theme.body.form2.textColor,
    height: '45px',
    padding: '0 14px',
    display: 'flex',
    alignItems: 'center',
  },
  '& .MuiInputLabel-outlined': {
    fontFamily: 'Raleway',
    fontSize: '14px',
    transform: 'translate(14px, 14px) scale(1)',
    color: theme.body.form2.textColor,
    '&.MuiInputLabel-shrink': {
      transform: 'translate(14px, -6px) scale(0.75)',
    },
  },
  '& .MuiSelect-icon': {
    top: 'calc(50% - 12px)',
  },
});

const OwnCustomSelect = styled(CustomSelect)(({ theme }) => (
  getInputStyles(theme)
));

const OwnCustomInput = styled(CustomInput)(({ theme }) => (
  getInputStyles(theme)
));

const OwnCustomAutocompleteImage = styled(CustomAutocompleteImage)(({ theme }) => (
  getInputStyles(theme)
));

const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: 700,
    fontStyle: 'normal',
    fontSize: '28px',
    lineHeight: theme.typography.h4.lineHeight,
    letterSpacing: '0em',
    color: `${theme.header.badgeItems.color}`,
    display: 'flex',
    alignItems: 'center',
    fontFamily: '"Karla"',
  },

  description: {
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '1.5',
    display: 'block',
    width: '100%',
    maxWidth: '800px',
    textAlign: 'left',
    fontFamily: '"Raleway"',
    letterSpacing: 0,
  },

  licenseCard: {
    backgroundColor: theme.body.cart.products.main,
    borderRadius: '20px',
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
  },

  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
  },

  vigenciaText: {
    color: `${theme.header.badgeItems.color}`,
    fontSize: '16px',
    marginBottom: theme.spacing(2),
    fontFamily: '"Raleway"',
    letterSpacing: 0,
  },

  actionBox: {
    backgroundColor: theme.body.cart.products.bodyCard,
    borderRadius: '12px',
    padding: '24px 16px 24px 16px',
    marginTop: '16px',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    boxSizing: 'border-box',
    minHeight: '208px',
  },

  textContainer: {
    display: 'flex',
    flexDirection: 'column',
  },

  dataRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '6px 0',
  },

  label: {
    fontWeight: 400,
    color: theme.body.cart.products.text,
    fontSize: '16px',
    lineHeight: '1.5rem',
    letterSpacing: 0,
    fontFamily: '"Raleway"',
  },

  value: {
    fontWeight: 600,
    color: theme.body.cart.products.text,
    fontSize: '16px',
    textAlign: 'right',
    lineHeight: '1.5rem',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '180px',
    [theme.breakpoints.down('xs')]: {
      maxWidth: '120px',
    },
    letterSpacing: 0,
    fontFamily: '"Raleway"',
  },

  fontValueNumber: {
    fontWeight: 600,
    color: theme.body.cart.products.text,
    fontSize: '16px',
    textAlign: 'right',
    lineHeight: '1.5rem',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '180px',
    [theme.breakpoints.down('xs')]: {
      maxWidth: '120px',
    },
    letterSpacing: 0,
    fontFamily: '"Karla"',
  },

  bigAssignBtn: {
    width: '100%',
    backgroundColor: theme.body.cart.products.bodyCard,
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,
    fontWeight: 600,
    textTransform: 'none',
    padding: '12px',
    borderRadius: '10px',
    marginTop: '24px',
    fontSize: '16px',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: theme.body.cart.products.main,
    },
    fontFamily: '"Karla"',
    letterSpacing: 0,
  },

  confirmBtn: {
    marginTop: theme.spacing(6),
    backgroundColor: theme.palette.primary.main,
    color: theme.body.cart.products.main,
    padding: '14px 60px',
    borderRadius: '12px',
    fontWeight: 700,
    textTransform: 'none',
    '&:hover': { backgroundColor: theme.palette.primary.hover },
    '&:disabled': { backgroundColor: theme.palette.primary.light },
  },
  titleItem: {
    fontWeight: 600,
    fontSize: '20px',
    lineHeight: theme.typography.h6.lineHeight,
    letterSpacing: '0em',
    verticalAlign: 'middle',
    display: 'flex',
    alignItems: 'center',
    fontFamily: '"Karla"',
  },
  switchBase: {
    color: theme.body.switchBase.color,
    '&$checked': {
      color: theme.palette.primary.main,
      '& + $track': {
        backgroundColor: theme.palette.primary.main,
      },
    },
    '&$disabled': {
      color: `${theme.body.switchBase.disabled.color} !important`,
      '& + $track': {
        backgroundColor: `${theme.body.switchBase.disabled.track.backgroundColor} !important`,
        opacity: 1,
      },
    },
  },
  checked: {},
  disabled: {},
  track: {
    backgroundColor: theme.body.switchBase.disabled.track.backgroundColor,
    opacity: 1,
  },
  customSelectFont: {
    fontFamily: "'Raleway'",
    '& .MuiSelect-select': {
      fontFamily: "'Raleway' !important",
    },
    '& .MuiInputLabel-root': {
      fontFamily: "'Raleway' !important",
    },
    '& *': {
      fontFamily: "'Raleway' !important",
    },
  },
  menuFont: {
    '& .MuiMenuItem-root': {
      fontFamily: "'Raleway'",
    },
  },
  styleInputs: {
    '& .MuiInputBase-root': {
      fontFamily: "'Karla'",
    },
    '& .MuiInputLabel-root': {
      fontFamily: "'Raleway'",
    },
    '& .MuiTypography-root': {
      fontFamily: "'Karla'",
    },
  },
}));

const LicenseAssignment = (props) => {
  const {
    itemsToAssign,
    updateLicense,
    deleteLicense,
    parameterApp,
    documentTypes,
    getParmeterConfig,
    getDocumentTypes,
    appName,
    tenant,
    loadingLoadProductsAssignments,
    saveProductsAssignments,
    saveAssignmentsSuccess,
    savingAssignmentsLoading,
    onReady,
    marketContext,
    productWasAssigned,
    getParametersMarket,
    getBlackListEmails,
    emailsInBalckList,
    getContractSupervisorInfoFunction,
    loadingContractSupervisorInfo,
    getContractSupervisorInfo,
    getCountriesFlags,
    countriesFlags,
  } = props;

  const {
    control,
    errors,
    handleSubmit,
    getValues,
    reset,
    setValue,
    watch,
    clearErrors,
    register,
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      firstName: '',
      lastName: '',
      documentTypeId: '',
      documentNumber: '',
      email: '',
      cellphone: '',
      countryCallingCode: '',
      countryCallingIso3: '',
      cityId: null,
      fullAddress: null,
    },
  });
  const classes = useStyles();
  const dispatch = useDispatch();
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [idToDelete, setIdToDelete] = useState(null);
  const [invalidDomains, setInvalidDomains] = useState([]);
  const [documentTypesSelect, setDocumentTypesSelect] = useState([{ value: 1, label: 'Cedula' }]);
  const allAssigned = itemsToAssign?.length > 0 && itemsToAssign.every((item) => item.assigned);
  const [currentItem, setCurrentItem] = useState({});
  const [buttonDialogStyle, setbuttonDialogStyle] = useState({
    acceptButton: {},
    cancelButton: {},
  });
  const whatchPersonType = watch('personType');
  const whatchDocumentType = watch('documentTypeId');
  const [useBillingData, setUseBillingData] = useState(false);
  const [haveErrors, setHaveErrors] = useState(false);
  const [currentCountry, setCurrentCountry] = useState({});
  const [defaultCountry, setDefaultCountry] = useState({});
  const theme = useTheme();

  const handleOpen = (item) => {
    setHaveErrors(false);
    setSelectedId(item.id);
    setCurrentItem(item);
    if (item.assigned) {
      reset(item.assigned);
      const isFromBilling = item.assigned.documentNumber === item.billing?.documentNumber
        && item.assigned.email === item.billing?.email;
      setUseBillingData(isFromBilling);
    } else {
      setUseBillingData(false);
      reset({
        firstName: '',
        lastName: '',
        documentTypeId: '',
        documentNumber: '',
        email: '',
        cellphone: '',
        indicative: defaultCountry?.value || '',
        countryCallingCode: defaultCountry?.phoneCode || '',
        countryCallingIso3: defaultCountry?.value || '',
        cityId: null,
        fullAddress: null,
      });
    }
    setbuttonDialogStyle({
      acceptButton: {
        backgroundColor: theme.palette.primary.main,
      },
      cancelButton: {
        backgroundColor: theme.palette.primary.contrastText,
        border: `1px solid ${theme.palette.primary.main}`,
        color: theme.palette.primary.main,
      },
    });
    setOpenDialog(true);
  };

  useEffect(() => {
    register('cityId');
    register('fullAddress');
  }, [register]);

  useEffect(() => {
    if (selectedId) {
      const found = itemsToAssign.find((item) => item.id === selectedId);
      setCurrentItem(found);
    }
  }, [selectedId, itemsToAssign]);

  const handleSave = () => {
    const formValues = getValues();
    const fullData = {
      ...formValues,
      fullAddress: useBillingData ? currentItem?.billing?.fullAddress : (formValues?.fullAddress || null),
      cityId: useBillingData ? currentItem?.billing?.cityId : (formValues?.cityId || null),
      countryCallingCode:
        formValues?.countryCallingCode
        || currentCountry?.phoneCode
        || currentItem?.billing?.countryCallingCode
        || null,
      countryCallingIso3:
        formValues?.countryCallingIso3
        || currentCountry?.value
        || currentItem?.billing?.countryCallingIso3
        || null,
    };
    updateLicense(selectedId, fullData);
    setOpenDialog(false);
    dispatch({ type: LOADING_CONTRACT_SUPERVISOR_INFO, payload: false });
    dispatch({ type: GET_CONTRACT_SUPERVISOR_INFO, payload: {} });
  };

  const handleOpenDelete = (id) => {
    setIdToDelete(id);
    setbuttonDialogStyle({
      acceptButton: {
        backgroundColor: theme.body.dialog.accept,
        letterSpacing: 0,
        fontFamily: '"Karla"',
        fontWeight: 600,
      },
      cancelButton: {
        backgroundColor: theme.palette.primary.contrastText,
        border: `1px solid ${theme.body.dialog.accept}`,
        color: theme.body.dialog.accept,
        letterSpacing: 0,
        fontFamily: '"Karla"',
        fontWeight: 600,
      },
    });
    setOpenDeleteDialog(true);
  };

  const handleConfirmDelete = () => {
    deleteLicense(idToDelete);
    setOpenDeleteDialog(false);
  };

  const getCodeCountry = (phoneCode) => {
    if (phoneCode) {
      return `${phoneCode.substring(0, 1)} ${phoneCode.substring(1)}`;
    }
    return '';
  };

  const { flagsCountries } = useMemo(() => {
    if (countriesFlags && Array.isArray(countriesFlags)) {
      const flags = countriesFlags.map((c) => ({
        value: c.iso3,
        label: getCodeCountry(c.phoneCode),
        image: c.flagUrl,
        maxPhoneLength: c.maxPhoneLength,
        minPhoneLength: c.minPhoneLength,
        phoneCode: c.phoneCode,
      }));

      const countries = countriesFlags.map((c) => ({
        value: c.iso3,
        label: c.countryName,
      }));

      return { flagsCountries: flags, countriesList: countries };
    }

    return { flagsCountries: [], countriesList: [] };
  }, [countriesFlags]);

  /**
   * Reform object from JsonDatabase and generate regex expresions
   * @param {*} array fromdatabase
   * @returns object similar to RHRules.js
   */
  const createRegex = (array) => {
    if (Array.isArray(array)) {
      return array.reduce((acc, item) => {
        // Usamos el id como llave y el resto del objeto como valor
        acc[item.id] = {
          ...item,
          rules: {
            ...item.rules,
            pattern: {
              ...item.rules?.pattern,
              value: item.rules?.pattern?.value ? new RegExp(item.rules?.pattern?.value) : '',
            },
          },
          cleanRegex: item.cleanRegex ? new RegExp(item.cleanRegex, 'g') : '',
          blockRegex: item.blockRegex ? new RegExp(item.blockRegex, 'g') : '',
        };
        return acc;
      }, {});
    }
    return {};
  };

  /**
   * Get rules for input field from system_parameter
   */
  const rulesParams = useMemo(() => {
    if (getParametersMarket && marketContext?.countryCode) {
      const rulesParam = getParametersMarket.find(
        (pm) => pm.parameterCode === 'Input_Rules'
          && pm.parameterKey === marketContext?.countryCode
          && pm.parameterValue,
      );
      if (rulesParam) {
        const rules = JSON.parse(rulesParam.parameterValue);
        if (rules) {
          const rulesWithRegex = createRegex(rules);
          return rulesWithRegex;
        }
      }
    }
    return {};
  }, [getParametersMarket, marketContext]);

  const passportRules = useMemo(() => ({
    rules: rulesParams?.passport?.rules ?? RulesAndRegex?.passport?.rules,
    cleanRegex: rulesParams?.passport?.cleanRegex ?? RulesAndRegex?.passport?.cleanRegex,
    blockRegex: rulesParams?.passport?.blockRegex ?? RulesAndRegex?.passport?.blockRegex,
    blockComposing:
      rulesParams?.passport?.blockComposing ?? RulesAndRegex?.passport?.blockComposing,
    maxLength:
      rulesParams?.passport?.rules?.maxLength?.value
      ?? RulesAndRegex?.passport?.rules?.maxLength?.value,
  }), [rulesParams, RulesAndRegex]);

  const nitRules = useMemo(() => ({
    rules: rulesParams?.NIT?.rules ?? RulesAndRegex?.NIT?.rules,
    cleanRegex: rulesParams?.NIT?.cleanRegex ?? RulesAndRegex?.NIT?.cleanRegex,
    blockRegex: rulesParams?.NIT?.blockRegex ?? RulesAndRegex?.NIT?.blockRegex,
    blockComposing: rulesParams?.NIT?.blockComposing ?? RulesAndRegex?.NIT?.blockComposing,
    maxLength:
      rulesParams?.NIT?.rules?.maxLength?.value ?? RulesAndRegex?.NIT?.rules?.maxLength?.value,
  }), [rulesParams, RulesAndRegex]);

  const defaultRules = useMemo(() => ({
    rules: rulesParams?.OtherDocuments?.rules
      ?? Rules.otrosDocumentosCustomMessage('El campo debe ser numérico, mínimo 5 y máximo 15 caracteres.'),
    cleanRegex: rulesParams?.OtherDocuments?.cleanRegex ?? RulesAndRegex?.NIT?.cleanRegex,
    blockRegex: rulesParams?.OtherDocuments?.blockRegex ?? RulesAndRegex?.NIT?.blockRegex,
    blockComposing:
      rulesParams?.OtherDocuments?.blockComposing ?? RulesAndRegex?.NIT?.blockComposing,
    maxLength: rulesParams?.OtherDocuments?.maxLength?.value ?? 15,
  }), [rulesParams, RulesAndRegex]);

  useEffect(() => {
    getDocumentTypes();
    getParmeterConfig(
      appName,
      'ParametersDocumentType',
      tenant,
    );
    getBlackListEmails();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (documentTypes) {
      const documentTypesChanged = documentTypes.map((doc) => ({
        identifier: doc.documentTypeCode,
        value: doc.id,
        label: doc.documentTypeDesciption,
      }));
      setDocumentTypesSelect(documentTypesChanged);
    }
  }, [documentTypes]);

  useEffect(() => {
    const keys = Object.keys(parameterApp);
    if (keys.length > 0 && documentTypesSelect.length > 0) {
      const arrayDocs = Object.entries(parameterApp);
      const docsFilterByPersonType = arrayDocs.filter(
        (doc) => doc[1]?.allowPersonType?.includes('N'),
      );
      const documentsFilter = documentTypesSelect.filter(
        (doc) => docsFilterByPersonType.some(
          (docfc) => docfc[0] === doc.identifier,
        ),
      );
      const documentsWithCountryLabel = documentsFilter.map((doc) => {
        const foundEntry = docsFilterByPersonType.find(
          (docE) => docE[0] === doc.identifier,
        );
        return {
          identifier: doc.identifier,
          value: doc.value,
          label: foundEntry?.[1].countryDescription || doc.label,
        };
      });
      setDocumentTypesSelect(documentsWithCountryLabel);
    }
    // eslint-disable-next-line
  }, [parameterApp]);

  useEffect(() => {
    if (emailsInBalckList) {
      const invalidsDomains = [];
      emailsInBalckList.forEach((email) => {
        invalidsDomains.push(email.regla);
      });
      setInvalidDomains(invalidsDomains);
    }
  }, [emailsInBalckList]);

  useEffect(() => {
    const previousValue = currentItem?.assigned?.documentTypeId || '';
    const hasUserChangedIt = whatchDocumentType !== previousValue;
    if (whatchDocumentType && !useBillingData && hasUserChangedIt) {
      reset({
        ...getValues(),
        documentNumber: '',
        firstName: '',
        lastName: '',
        email: '',
        cellphone: '',
        countryCallingCode: '',
        cityId: null,
        fullAddress: null,
      });
      clearErrors();
    }
  }, [whatchDocumentType, reset, getValues, clearErrors, useBillingData]);

  useEffect(() => {
    if (getContractSupervisorInfo && Object.keys(getContractSupervisorInfo).length > 0) {
      setTimeout(() => {
        setValue('firstName', getContractSupervisorInfo.firstName || '');
        setValue('lastName', getContractSupervisorInfo.lastName || '');
        setValue('email', getContractSupervisorInfo.email || '');
        setValue('cellphone', getContractSupervisorInfo.phoneNumber || '');
        setValue('cityId', (getContractSupervisorInfo.cityId === 0 || !getContractSupervisorInfo.cityId) ? null : getContractSupervisorInfo.cityId);
        setValue('fullAddress', (getContractSupervisorInfo.fullAddress === '' || !getContractSupervisorInfo.fullAddress) ? null : getContractSupervisorInfo.fullAddress);
        const matchedCountry = flagsCountries.find(
          (country) => country.phoneCode === getContractSupervisorInfo.countryCallingCode
        );
        if (matchedCountry) {
          setCurrentCountry(matchedCountry);
          setValue('indicative', matchedCountry.value);
          setValue('countryCallingCode', matchedCountry.phoneCode);
          setValue('countryCallingIso3', matchedCountry.value);
        }
      }, 100);
    }
  }, [getContractSupervisorInfo, setValue, flagsCountries]);

  useEffect(() => {
    if (
      flagsCountries?.length > 0
      && marketContext?.countryCode
      && !getContractSupervisorInfo?.countryCallingCode
    ) {
      const currentCount = flagsCountries.find((cou) => cou.value === marketContext?.countryCode);

      if (currentCount) {
        setCurrentCountry(currentCount);
        setDefaultCountry(currentCount);
        setValue('indicative', currentCount.value);
        setValue('countryCallingCode', currentCount.phoneCode);
        setValue('countryCallingIso3', currentCount.value);
      }
    }
  }, [flagsCountries, marketContext?.countryCode, getContractSupervisorInfo?.countryCallingCode]);

  useEffect(() => {
    getCountriesFlags();
    if (marketContext?.regionCode && marketContext?.countryCode) {
      getCountriesFlags();
    }
    // eslint-disable-next-line
    }, [marketContext?.regionCode, marketContext?.countryCode]);

  const getIdentifierDocumentType = (idDoc) => {
    const document = documentTypesSelect.find(
      (doc) => doc.value === idDoc,
    );
    return document?.identifier || '';
  };

  const handleToggleBilling = (checked) => {
    setUseBillingData(checked);
    if (checked && currentItem?.billing) {
      const data = currentItem.billing;
      const country = flagsCountries.find(
        (item) => item.phoneCode === data.countryCallingCode,
      );
      setCurrentCountry(country);
      setTimeout(() => {
        setValue('firstName', data.firstName, { shouldValidate: true });
        setValue('lastName', data.lastName, { shouldValidate: true });
        setValue('documentTypeId', data.documentTypeId, { shouldValidate: true });
        setValue('documentNumber', data.documentNumber, { shouldValidate: true });
        setValue('email', data.email, { shouldValidate: true });
        setValue('cellphone', data.cellphone, { shouldValidate: true });
        setValue('indicative', country?.value || '', { shouldValidate: true });
        setValue('countryCallingCode', country?.phoneCode || null, { shouldValidate: true });
        setValue('countryCallingIso3', country?.value || null, { shouldValidate: true });
      }, 50);
    } else {
      const currentCount = flagsCountries.find(
        (cou) => cou.value === marketContext?.countryCode,
      );
      reset({
        firstName: '',
        lastName: '',
        documentTypeId: '',
        documentNumber: '',
        email: '',
        cellphone: '',
        indicative: currentCount?.value || '',
        countryCallingCode: currentCount?.phoneCode || '',
        countryCallingIso3: currentCount?.value || '',
        cityId: null,
        fullAddress: null,
      });
      if (currentCount) {
        setCurrentCountry(currentCount);
      }
    }
  };

  const handleConfirm = () => {
    if (allAssigned) {
      setHaveErrors(false);
      const payload = {
        ReferenceUuid: marketContext?.referenceUuid,
        CountryCode: marketContext?.countryCode,
        AssignProducts: itemsToAssign.map((item) => {
          const isDelegated = item.isDelegatedManagement;
          return {
            IsSingleQuantity: !isDelegated,
            PurchaseOrderLicenseId: item.id,
            AssignCustomer: !isDelegated ? {
              personType: 'N',
              documentTypeId: item.assigned.documentTypeId,
              documentNumber: item.assigned.documentNumber,
              firstName: item.assigned.firstName,
              lastName: item.assigned.lastName,
              cellphoneNumber: item.assigned.cellphone,
              countryCallingCode: item.assigned.countryCallingCode,
              countryCallingIso3: item.assigned.countryCallingIso3,
              email: item.assigned.email,
              fullAddress: item.assigned.fullAddress,
              cityId: item.assigned.cityId,
            } : null,

            AssignSupervisor: isDelegated ? {
              personType: 'N',
              documentTypeId: item.assigned.documentTypeId,
              documentNumber: item.assigned.documentNumber,
              firstName: item.assigned.firstName,
              lastName: item.assigned.lastName,
              phoneNumber: item.assigned.cellphone,
              countryCallingCode: item.assigned.countryCallingCode,
              countryCallingIso3: item.assigned.countryCallingIso3,
              email: item.assigned.email,
              fullAddress: item.assigned.fullAddress,
              cityId: item.assigned.cityId,
            } : null,
          };
        }),
      };
      saveProductsAssignments(payload);
    } else {
      setHaveErrors(true);
    }
  };

  /**
   * Rules changed by document type
   * @param {*} persontype Natural o legal
   * @param {*} watchDocType NIT, Passport,CC ....
   * @returns a validation for these documetn type
   */
  const getValidationsByDocumentType = (persontype, watchDocType) => {
    if (watchDocType === 6 || watchDocType === 10 || watchDocType === 13) {
      return passportRules;
    } if (watchDocType === 4 && persontype === 'J') {
      return nitRules;
    }
    return defaultRules;
  };

  const getValidityLabel = (type, period) => {
    const labels = {
      A: period === 1 ? 'Año' : 'Años',
      M: period === 1 ? 'Mes' : 'Meses',
      D: period === 1 ? 'Día' : 'Días',
      H: period === 1 ? 'Hora' : 'Horas',
      I: 'Ilimitada',
    };
    return labels[type] || '';
  };

  const getDeviceLabel = (codeDevice) => {
    const deviceLabelsParam = getParametersMarket?.find(
      (param) => param?.parameterCode === 'Device_Labels'
      && param.parameterKey?.toUpperCase() === tenant?.toUpperCase()
      && param.parameterValue?.toUpperCase() === codeDevice?.toUpperCase(),
    );

    if (deviceLabelsParam?.parameterDescription) {
      return deviceLabelsParam.parameterDescription;
    }

    const defaultLabels = {
      FC: 'Centralizado',
      TK: 'Token',
      P12: 'P12',
    };

    return defaultLabels[codeDevice] || 'Desconocido';
  };

  const getTitleText = (item) => {
    const title = item?.title || '';
    if (item?.isDelegatedManagement) {
      const pluralized = title
        .replace(/Certificado/gi, 'Certificados')
        .replace(/Digital/gi, 'Digitales');

      return `Asignación de supervisor para ${pluralized}`;
    }
    return `Asignación de ${title}`;
  };

  /**
   * Sanitizes the input value by removing characters that don't match the regex.
   * @param {string} inputValue - The current value of the input (e.g., firstName).
   * @param {RegExp} cleanRegex - The allowed pattern; non-matching characters will be removed.
  */
  const cleanInput = (inputValue, cleanRegex) => {
    const originalValue = getValues(inputValue);
    const cleanValue = originalValue?.replace(cleanRegex, '');
    setValue(inputValue, cleanValue);
    clearErrors();
    if (inputValue === 'documentNumber' && !errors.documentNumber && whatchDocumentType && cleanValue) {
      getContractSupervisorInfoFunction(whatchDocumentType, cleanValue, marketContext?.countryCode, true);
    }
  };

  const isDataReady = (productWasAssigned || (itemsToAssign.length > 0 && documentTypes.length > 0))
    && !loadingLoadProductsAssignments && emailsInBalckList;

  useEffect(() => {
    if (isDataReady) {
      onReady();
    }
  }, [isDataReady, onReady]);

  if (saveAssignmentsSuccess) {
    return <Success />;
  }

  if (!isDataReady) return null;

  const capitalizeName = (name) => name
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

  /**
   * Create rule with invalid domins list
   * @param {*} value entry of user example: email@yopmail.com
   * @returns true if there is no problem, message if domain is invalid
   */
  const validateEmail = (value) => {
    if (!value) {
      return true;
    }
    // Verify if email have a domain in black list
    const domain = value.split('@')[1];
    if (domain && invalidDomains.includes(`@${domain}`)) {
      return 'El dominio de correo ingresado no es permitido.';
    }
    return true;
  };

  return (
    <>
      {productWasAssigned ? (
        <WarningLicenseAssignment />
      ) : (
        <Container maxWidth="lg">
          <Box
            style={{
              backgroundColor: theme.body.cart.assigment.bgColor,
              width: '100vw',
              position: 'relative',
              left: '50%',
              right: '50%',
              marginLeft: '-50vw',
              marginBottom: '32px',
              padding: '24px 0',
            }}
          >
            <Container maxWidth="lg">
              <Box display="flex" alignItems="center" mb={1}>
                <HowToRegOutlinedIcon style={{ fontSize: '30px', marginRight: '10px' }} />
                <Typography variant="h4" className={classes.title}>
                  Asigna los productos que compraste
                </Typography>
              </Box>
              <Typography className={classes.description}>
                <span style={{ display: 'block' }}>
                  Debes asignar todos los productos adquiridos. Si tienes dudas sobre la asignación,
                </span>
                <span style={{ display: 'block' }}>
                  te recomendamos revisarla antes de continuar.
                </span>
              </Typography>
            </Container>
          </Box>
          <Grid container spacing={3} alignItems="stretch">
            {itemsToAssign.map((item) => {
              const isPackage = item.isDelegatedManagement;
              const roleLabel = isPackage ? 'Supervisor' : 'Titular';

              return (
                <Grid item xs={12} sm={6} key={item.id} style={{ display: 'flex' }}>
                  <Box className={classes.licenseCard}>

                    <Box className={classes.titleContainer}>
                      <img
                        src={verifiedLicense}
                        alt="Verified License"
                        style={{
                          width: '24px',
                          height: '24px',
                          display: 'block',
                        }}
                      />
                      <Typography className={classes.titleItem}>
                        {item.title}
                      </Typography>
                    </Box>

                    <Typography
                      className={classes.vigenciaText}
                      style={{
                        paddingLeft: '34px',
                        fontSize: '16px',
                      }}
                    >
                      Vigencia:
                      {' '}
                      <b style={{ fontWeight: 600 }}>
                        {item.validityTypeId === 'I'
                          ? getValidityLabel(item.validityTypeId)
                          : `${item.validityPeriod} ${getValidityLabel(item.validityTypeId, item.validityPeriod)}`}
                      </b>
                      {'\u00A0\u00A0\u00A0'}
                      Formato:
                      {' '}
                      <b style={{ fontWeight: 600 }}>{getDeviceLabel(item.deviceCode)}</b>
                      {'\u00A0\u00A0\u00A0'}
                      Cantidad:
                      {' '}
                      <b style={{ fontWeight: 600 }}>{item.quantity}</b>
                    </Typography>

                    <Box className={classes.actionBox}>
                      {!item.assigned ? (
                        <>
                          <Box className={classes.textContainer}>
                            <Box
                              display="flex"
                              alignItems="center"
                              mb={1}
                            >
                              <Box display="flex" alignItems="center" style={{ marginRight: '8px' }}>
                                {item.isDelegatedManagement ? (
                                  <img
                                    src={GroupsPerson}
                                    alt="Verified"
                                    style={{
                                      width: '24px', height: '24px', display: 'block', transform: 'translateY(-1px)',
                                    }}
                                  />
                                ) : (
                                  <PersonOutlinedIcon style={{ fontSize: 24, display: 'block', transform: 'translateY(-1px)' }} />
                                )}
                              </Box>
                              <Typography
                                style={{
                                  fontWeight: 600,
                                  fontSize: '16px',
                                  color: theme.header.badgeItems.color,
                                  lineHeight: 1,
                                  display: 'flex',
                                  alignItems: 'center',
                                  fontFamily: '"Raleway"',
                                  letterSpacing: 0,
                                }}
                              >
                                {item.isDelegatedManagement
                                  ? 'Compra múltiple - Gestión delegada'
                                  : 'Compra individual - Asignación directa'}
                              </Typography>
                            </Box>
                            <Typography
                              style={{
                                fontFamily: '"Raleway"',
                                fontWeight: 400,
                                fontSize: '16px',
                                lineHeight: 1.5,
                                letterSpacing: '0%',
                                color: theme.body.cart.products.text,
                                textAlign: 'left',
                              }}
                            >
                              {item.isDelegatedManagement
                                ? 'Deberás designar un administrador del paquete, el administrador será responsable de asignar cada certificado a sus respectivos titulares.'
                                : 'Deberás ingresar los datos del titular del certificado, este quedará asignado directamente a esta persona.'}
                            </Typography>
                          </Box>

                          <Button
                            variant="contained"
                            className={classes.bigAssignBtn}
                            endIcon={<ArrowForwardIcon />}
                            onClick={() => handleOpen(item)}
                          >
                            Asignar
                          </Button>
                        </>
                      ) : (
                        <>
                          <Box display="flex" justifyContent="space-between" alignItems="center" mb={1.5}>
                            <Box display="flex" alignItems="center">
                              {item.isDelegatedManagement ? (
                                <img
                                  src={GroupsPerson}
                                  alt="Verified"
                                  style={{
                                    width: '24px', height: '24px', display: 'block', transform: 'translateY(-1px)', marginRight: '8px',
                                  }}
                                />
                              ) : (
                                <PersonOutlinedIcon style={{
                                  fontSize: 24, display: 'block', transform: 'translateY(-1px)', marginRight: '8px',
                                }}
                                />
                              )}
                              <Typography
                                style={{
                                  fontWeight: 700,
                                  fontSize: '16px',
                                  color: theme.body.cart.products.text,
                                  lineHeight: 1,
                                  letterSpacing: 0,
                                  fontFamily: '"Raleway"',
                                }}
                              >
                                Datos del
                                {' '}
                                {roleLabel}
                              </Typography>
                            </Box>
                            <Box>
                              <IconButton size="small" onClick={() => handleOpen(item)} style={{ color: theme.palette.primary.main }}>
                                <EditIcon fontSize="small" />
                              </IconButton>
                              <IconButton size="small" onClick={() => handleOpenDelete(item.id)} style={{ color: theme.palette.primary.main }}>
                                <DeleteOutlineIcon fontSize="small" />
                              </IconButton>
                            </Box>
                          </Box>

                          <Box className={classes.dataRow}>
                            <Typography className={classes.label}>Nombre:</Typography>
                            <Tooltip title={`${item?.assigned?.firstName} ${item?.assigned?.lastName}`} arrow placement="top">
                              <Typography
                                className={classes.value}
                              >
                                {capitalizeName(`${item?.assigned?.firstName} ${item?.assigned?.lastName}`)}
                              </Typography>
                            </Tooltip>
                          </Box>

                          <Box className={classes.dataRow}>
                            <Typography className={classes.label}>Tipo y número de documento:</Typography>

                            <Tooltip
                              title={`${getIdentifierDocumentType(item?.assigned?.documentTypeId)} ${item?.assigned?.documentNumber}`}
                              arrow
                              placement="top"
                            >
                              <Typography className={classes.value}>
                                <span>
                                  {getIdentifierDocumentType(item?.assigned?.documentTypeId)}
                                </span>
                                <span className={classes.fontValueNumber}>
                                  {` ${item?.assigned?.documentNumber}`}
                                </span>
                              </Typography>
                            </Tooltip>
                          </Box>

                          <Box className={classes.dataRow}>
                            <Typography className={classes.label}>Correo:</Typography>
                            <Tooltip title={item?.assigned?.email} arrow placement="top">
                              <Typography className={classes.value}>{item?.assigned?.email}</Typography>
                            </Tooltip>
                          </Box>

                          <Box className={classes.dataRow}>
                            <Typography className={classes.label}>Número móvil:</Typography>
                            <Tooltip title={item?.assigned?.cellphone} arrow placement="top">
                              <Typography
                                className={classes.fontValueNumber}
                              >
                                {`${item?.assigned?.countryCallingCode || ''} ${item?.assigned?.cellphone || ''}`.trim()}
                              </Typography>
                            </Tooltip>
                          </Box>

                          {item.assigned.cargo && (
                            <Box className={classes.dataRow}>
                              <Typography className={classes.label}>Cargo:</Typography>
                              <Tooltip title={item.assigned.cargo} arrow placement="top">
                                <Typography className={classes.value}>{item.assigned.cargo}</Typography>
                              </Tooltip>
                            </Box>
                          )}
                        </>
                      )}
                    </Box>
                  </Box>
                </Grid>
              );
            })}
          </Grid>
          {haveErrors && (
            <>
              <Box sx={{ mt: 4 }} />
              <Box style={{
                backgroundColor: theme.body.form.bkgColorErr,
                width: '100%',
                margin: 0,
                borderRadius: 10,
                paddingBottom: -50,
              }}
              >
                <Grid
                  container
                  style={{
                    padding: 14,
                  }}
                >
                  <Grid
                    item
                    xs={12}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <ErrorIcon style={{
                      color: theme.body.form.iconErrColor,
                    }}
                    />
                    <Typography style={{
                      color: theme.body.form.colorErrText,
                      fontSize: 14,
                      fontWeight: 700,
                      paddingLeft: 16,
                      fontFamily: '"Raleway"',
                      letterSpacing: 0,
                    }}
                    >
                      {'¡Debes asignar todos los certificados! \n'}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography style={{
                      color: theme.body.form.colorErrText,
                      fontSize: 14,
                      fontWeight: 500,
                      paddingLeft: 39,
                      fontFamily: '"Raleway"',
                      letterSpacing: 0,
                    }}
                    >
                      Ten en cuenta que si cierras esta ventana sin confirmar,
                      los productos no quedarán asignados.
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            </>
          )}
          <Box display="flex" justifyContent="flex-end" mb={2} mt={haveErrors ? -4 : 0}>
            <Button
              variant="contained"
              className={classes.confirmBtn}
              onClick={() => {
                if (savingAssignmentsLoading) return;
                handleConfirm();
              }}
              style={{
                padding: '10px 40px',
                fontWeight: 700,
                opacity: savingAssignmentsLoading ? 0.8 : 1,
              }}
            >
              {savingAssignmentsLoading ? (
                <Box display="flex" alignItems="center" gap="10px">
                  <CircularProgress size={20} style={{ color: theme.header.colorText }} />
                  <Typography style={{
                    color: theme.header.colorText,
                    marginLeft: '8px',
                    fontFamily: '"Karla"',
                    letterSpacing: 0,
                  }}
                  >
                    Confirmando...
                  </Typography>
                </Box>
              ) : (
                <Typography style={{
                  color: theme.header.colorText,
                  fontFamily: '"Karla"',
                  letterSpacing: 0,
                }}
                >
                  Confirmar
                </Typography>
              )}
            </Button>
          </Box>
          <CustomDialog
            isOpen={openDialog}
            setIsOpen={(val) => {
              setOpenDialog(val);
              if (!val) {
                dispatch({ type: LOADING_CONTRACT_SUPERVISOR_INFO, payload: false });
                dispatch({ type: GET_CONTRACT_SUPERVISOR_INFO, payload: {} });
              }
            }}
            maxWidthValue={608}
            textTitle={(
              <Typography
                style={{
                  fontWeight: 700, fontSize: '24px', letterSpacing: 0, fontFamily: '"Karla"', marginBottom: '20px',
                }}
              >
                {getTitleText(currentItem)}
              </Typography>
            )}
            textContent={currentItem?.isDelegatedManagement ? 'Datos del supervisor' : 'Datos del titular'}
            typographyProps={{
              letterSpacing: 0,
              fontFamily: '"Karla"',
            }}
            textAccept="Confirmar"
            textCloseDialog="Cancelar"
            acceptAction={handleSubmit(handleSave)}
            showIcon={false}
            alignLeft
            acceptButtonStyle={buttonDialogStyle.acceptButton}
            cancelButtonStyle={buttonDialogStyle.cancelButton}
          >
            <Box
              display="flex"
              alignItems="center"
              mb="10px"
              style={{
                opacity: currentItem?.billing?.personType === 'J' ? 0.5 : 1,
                transition: 'opacity 0.2s',
              }}
            >
              <Typography
                style={{
                  color: theme.body.cart.products.text,
                  fontSize: '16px',
                  fontWeight: 500,
                  letterSpacing: 0,
                  fontFamily: '"Raleway"',
                }}
              >
                Usar datos de facturación
              </Typography>

              <FormControlLabel
                style={{
                  margin: 0,
                  marginLeft: '8px',
                }}
                control={(
                  <Switch
                    checked={useBillingData}
                    onChange={(e) => handleToggleBilling(e.target.checked)}
                    disabled={currentItem?.billing?.personType === 'J'}
                    classes={{
                      switchBase: classes.switchBase,
                      checked: classes.checked,
                      disabled: classes.disabled,
                      track: classes.track,
                    }}
                  />
                )}
                label=""
              />
            </Box>
            <Grid container spacing={2} style={{ marginBottom: '16px' }}>
              <Grid item xs={12}>
                <OwnCustomSelect
                  label="Tipo de documento"
                  name="documentTypeId"
                  options={documentTypesSelect}
                  control={control}
                  rule={Rules.required}
                  required
                  error={errors}
                  disabled={useBillingData || loadingContractSupervisorInfo}
                  iconExpandMore={ExpandMoreIcon}
                  styleFromHelperText={{ style: { fontFamily: '"Raleway"', letterSpacing: 0 } }}
                  className={classes.customSelectFont}
                  inputProps={{
                    MenuProps: { classes: { paper: classes.menuFont } },
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div style={{ flexGrow: 1 }}>
                    <OwnCustomInput
                      label="Número de documento"
                      name="documentNumber"
                      control={control}
                      styleFromHelperText={{ style: { fontFamily: '"Raleway"', letterSpacing: 0 } }}
                      onValidate={() => {
                        const currentValues = getValues();
                        const hasData = currentValues.firstName
                          || currentValues.lastName
                          || currentValues.email
                          || currentValues.cellphone;
                        if (hasData) {
                          reset({
                            ...currentValues,
                            firstName: '',
                            lastName: '',
                            email: '',
                            cellphone: '',
                            cityId: null,
                            fullAddress: null,
                          });
                          clearErrors();
                        }
                      }}
                      rule={
                        getValidationsByDocumentType(
                          whatchPersonType,
                          whatchDocumentType,
                        )?.rules
                      }
                      error={errors}
                      required
                      disabled={useBillingData || loadingContractSupervisorInfo}
                      inputProps={{
                        maxLength: getValidationsByDocumentType(
                          whatchPersonType,
                          whatchDocumentType,
                        )?.maxLength,
                      }}
                      cleanInputPattern={getValidationsByDocumentType(
                        whatchPersonType,
                        whatchDocumentType,
                      )?.cleanRegex}
                      blockComposing={getValidationsByDocumentType(
                        whatchPersonType,
                        whatchDocumentType,
                      )?.blockComposing}
                      onBlur={() => {
                        cleanInput('documentNumber', getValidationsByDocumentType(whatchPersonType, whatchDocumentType)?.cleanRegex);
                      }}
                      className={classes.styleInputs}
                    />
                  </div>
                  {
                    loadingContractSupervisorInfo && (
                      <div style={{ marginLeft: '10px', minWidth: '20px' }}>
                        <CircularProgress size={20} color="primary" />
                      </div>
                    )
                  }
                </div>
              </Grid>
              <Grid item xs={12}>
                <OwnCustomInput
                  label="Nombres"
                  name="firstName"
                  control={control}
                  styleFromHelperText={{ style: { fontFamily: '"Raleway"', letterSpacing: 0 } }}
                  error={errors}
                  rule={
                    rulesParams?.namesAndSurnames?.rules
                    ?? Rules?.letrasTildes
                  }
                  required
                  inputProps={{
                    maxLength:
                      rulesParams?.namesAndSurnames?.rules?.maxLength?.value
                      ?? RulesAndRegex?.namesAndSurnames?.rules?.maxLength?.value,
                  }}
                  cleanInputPattern={
                    rulesParams?.namesAndSurnames?.cleanRegex
                    ?? RulesAndRegex?.namesAndSurnames?.cleanRegex
                  }
                  blockComposing={
                    rulesParams?.namesAndSurnames?.blockComposing
                    ?? RulesAndRegex?.namesAndSurnames?.blockComposing
                  }
                  onBlur={() => {
                    cleanInput(
                      'firstName',
                      rulesParams?.namesAndSurnames?.cleanRegex
                      ?? RulesAndRegex?.namesAndSurnames?.cleanRegex,
                    );
                  }}
                  className={classes.customSelectFont}
                />
              </Grid>
              <Grid item xs={12}>
                <OwnCustomInput
                  label="Apellidos"
                  name="lastName"
                  control={control}
                  styleFromHelperText={{ style: { fontFamily: '"Raleway"', letterSpacing: 0 } }}
                  error={errors}
                  rule={
                    rulesParams?.namesAndSurnames?.rules
                    ?? Rules?.letrasTildes
                  }
                  required
                  inputProps={{
                    maxLength:
                      rulesParams?.namesAndSurnames?.rules?.maxLength?.value
                      ?? RulesAndRegex?.namesAndSurnames?.rules?.maxLength?.value,
                  }}
                  cleanInputPattern={
                    rulesParams?.namesAndSurnames?.cleanRegex
                    ?? RulesAndRegex?.namesAndSurnames?.cleanRegex
                  }
                  blockComposing={
                    rulesParams?.namesAndSurnames?.blockComposing
                    ?? RulesAndRegex?.namesAndSurnames?.blockComposing
                  }
                  onBlur={() => {
                    cleanInput('lastName',
                      RulesAndRegex?.namesAndSurnames?.cleanRegex
                      ?? RulesAndRegex?.namesAndSurnames?.cleanRegex);
                  }}
                  className={classes.customSelectFont}
                />
              </Grid>
              <Grid item xs={12}>
                <OwnCustomInput
                  label="Correo"
                  name="email"
                  control={control}
                  styleFromHelperText={{ style: { fontFamily: '"Raleway"', letterSpacing: 0 } }}
                  rule={{
                    ...rulesParams?.email?.rules,
                    validate: validateEmail,
                  }}
                  error={errors}
                  required
                  inputProps={{
                    maxLength:
                      rulesParams?.email?.rules?.maxLength?.value
                      ?? RulesAndRegex?.email?.rules?.maxLength?.value,
                  }}
                  className={classes.customSelectFont}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <OwnCustomAutocompleteImage
                  label="Indicativo"
                  name="indicative"
                  options={flagsCountries || []}
                  control={control}
                  rule={Rules.required}
                  required
                  error={errors}
                  iconExpandMore={<ExpandMoreIcon />}
                  noWrap
                  disabled={loadingContractSupervisorInfo}
                  styleFromHelperText={{ style: { fontFamily: '"Raleway"', letterSpacing: 0 } }}
                  className={classes.customSelectFont}
                  inputProps={{
                    MenuProps: { classes: { paper: classes.menuFont } },
                  }}
                  onChange={(value) => {
                    setValue('cellphone', '');
                    const country = flagsCountries.find(
                      (item) => item.value === value,
                    );
                    setCurrentCountry(country);
                    setValue('countryCallingCode', country?.phoneCode || null);
                    setValue('countryCallingIso3', country?.value || null);
                  }}
                />
              </Grid>
              <Grid item xs={12} md={8}>
                <OwnCustomInput
                  label="Número móvil"
                  name="cellphone"
                  control={control}
                  styleFromHelperText={{ style: { fontFamily: '"Raleway"', letterSpacing: 0 } }}
                  rule={{
                    // ...rulesParams?.cellPhone?.rules ?? RulesAndRegex?.cellPhone?.rules,
                    required: 'Campo obligatorio',
                    validate: (value) => {
                      const minLengthRequired = currentCountry?.minPhoneLength;
                      if (!minLengthRequired) return true;
                      if (value && value.length < minLengthRequired) {
                        return `Mínimo ${minLengthRequired} caracteres para este país`;
                      }
                      return true;
                    },
                  }}
                  error={errors}
                  required
                  inputProps={{
                    maxLength: currentCountry?.maxPhoneLength,
                  }}
                  cleanInputPattern={
                    rulesParams?.cellPhone?.cleanRegex
                    ?? RulesAndRegex?.cellPhone?.cleanRegex
                  }
                  blockComposing={
                    rulesParams?.cellPhone?.blockComposing
                    ?? RulesAndRegex?.cellPhone?.blockComposing
                  }
                  onBlur={() => {
                    cleanInput('phone',
                      rulesParams?.cellPhone?.cleanRegex
                      ?? RulesAndRegex?.cellPhone?.cleanRegex);
                  }}
                  className={classes.styleInputs}
                />
              </Grid>
            </Grid>
          </CustomDialog>
          <CustomDialog
            isOpen={openDeleteDialog}
            setIsOpen={setOpenDeleteDialog}
            textTitle="¿Deseas eliminar esta asignación?"
            textAccept="Si, eliminar"
            textCloseDialog="Cancelar"
            acceptAction={handleConfirmDelete}
            acceptButtonStyle={buttonDialogStyle.acceptButton}
            cancelButtonStyle={buttonDialogStyle.cancelButton}
            showIcon
            showChildren={false}
            showSpaceDown
          />
        </Container>
      )}
    </>
  );
};

const mapStateToProps = (props) => ({
  itemsToAssign: props.license.itemsToAssign || [],
  parameterApp: props.general.parameterApp,
  documentTypes: props.general.documentTypes,
  loadingLoadProductsAssignments: props.license.loadingLoadProductsAssignments,
  saveAssignmentsSuccess: props.license.saveAssignmentsSuccess,
  savingAssignmentsLoading: props.license.savingAssignmentsLoading,
  marketContext: props.license.marketContext,
  productWasAssigned: props.license.productWasAssigned,
  getParametersMarket: props.general.getParametersMarket,
  emailsInBalckList: props.emails.emailsBlackList,
  loadingContractSupervisorInfo: props.license.loadingContractSupervisorInfo,
  loadingContractCustomerInfo: props.license.loadingContractCustomerInfo,
  getContractSupervisorInfo: props.license.getContractSupervisorInfo,
  countriesFlags: props.license.countriesFlags,
});

const mapDispatchToProps = {
  updateLicense: updateLicenseInReduxAction,
  deleteLicense: deleteLicenseAssignmentAction,
  getDocumentTypes: getDocumentTypesAction,
  getParmeterConfig: getParmeterConfigAction,
  saveProductsAssignments: saveProductsAssignmentsAction,
  getBlackListEmails: getBlackListEmailsAction,
  getContractSupervisorInfoFunction: getContractSupervisiorInfoAction,
  getCountriesFlags: GetCountriesFlagsAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(LicenseAssignment);
